import {
  INPATIENT,
  INPATIENT_PLUS,
  OBSERVATION,
  OBSERVATION_PLUS,
} from '../constants/MeLValues.constants';

export const MeLValueRenderer = ({ value }) => {
  switch (value) {
    case INPATIENT:
      return 'I';
    case 'I':
      return 'I';
    case OBSERVATION:
      return 'O';
    case 'O':
      return 'O';
    case INPATIENT_PLUS:
      return 'I+';
    case OBSERVATION_PLUS:
      return 'O+';
    default:
      return '';
  }
};
